import React, { useEffect, useState, useCallback } from "react";
import { Toaster } from "sonner";
import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { GallerySection } from "../components/site/GallerySection";
import { CompletedProjects } from "../components/site/CompletedProjects";
import { Capabilities } from "../components/site/Capabilities";
import { WorkPlatform } from "../components/site/WorkPlatform";
import { WhyUs } from "../components/site/WhyUs";
import { Testimonials } from "../components/site/Testimonials";
import { ContactSection } from "../components/site/ContactSection";
import { Footer } from "../components/site/Footer";
import { fetchGallery } from "../lib/api";

export default function GalleryPage() {
  const [data, setData] = useState({ categories: [], structures: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    fetchGallery()
      .then((d) => {
        if (mounted) setData(d);
      })
      .catch((e) => {
        if (mounted) setError(e?.message || "Failed to load gallery");
      })
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, []);

  const scrollTo = useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
    else el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return (
    <div className="min-h-screen">
      <Toaster position="top-center" richColors closeButton />
      <Navbar onContactClick={() => scrollTo("contact")} />

      <Hero
        onExplore={() => scrollTo("gallery")}
        onContact={() => scrollTo("contact")}
      />

      {loading ? (
        <div className="py-24 text-center text-slate-500 font-mono text-sm uppercase tracking-widest">
          Loading structures…
        </div>
      ) : error ? (
        <div className="py-24 text-center text-red-500 font-mono text-sm">
          {error}
        </div>
      ) : (
        <GallerySection
          structures={data.structures}
          categories={data.categories}
        />
      )}

      <CompletedProjects />
      <Capabilities />
      <WorkPlatform />
      <WhyUs />
      <Testimonials />
      <ContactSection />
      <Footer />
    </div>
  );
}
